import React, { useState } from "react";
import { AuthProvider } from "./hooks/useAuth";
import { ChatProvider, useChatContext } from "./contexts/ChatContext";
import ChatWidget from "./components/ChatWidget";
import AdminDashboard from "./components/AdminDashboard";
import UserDashboard from "./components/UserDashboard";
import AdminRoute from "./components/AdminRoute";
import PrivateRoute from "./components/PrivateRoute";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import {
  FiMessageCircle,
  FiUsers,
  FiSettings,
  FiStar,
  FiHeart,
  FiZap,
  FiShield,
  FiPlay,
  FiCheck,
  FiPhone,
  FiMail,
  FiMapPin,
  FiLogOut,
} from "react-icons/fi";
import { Toaster } from "react-hot-toast";
import { useAuth } from "./hooks/useAuth";
import { FaPaw } from "react-icons/fa";
import AuthForm from "./components/ChatWidget/AuthForm";
import { useNavigate } from "react-router-dom";
import { stripeAPI } from "./api/index";
import toast from "react-hot-toast";




const Navigation = ({ onSignInClick }: { onSignInClick: () => void }) => {
  const { user, signOut } = useAuth();

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-2xl font-bold text-primary flex items-center">
                <FaPaw className="text-orange mr-2" size={28} />
                {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}
              </h1>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#services"
                className="text-primary hover:text-orange transition-colors font-medium"
              >
                Services
              </a>
              <a
                href="#about"
                className="text-primary hover:text-orange transition-colors font-medium"
              >
                About
              </a>
              <a
                href="#testimonials"
                className="text-primary hover:text-orange transition-colors font-medium"
              >
                Reviews
              </a>
              <a
                href="#pricing"
                className="text-primary hover:text-orange transition-colors font-medium"
              >
                Pricing
              </a>{" "}
              {/* 👈 New */}
              <a
                href="#contact"
                className="text-primary hover:text-orange transition-colors font-medium"
              >
                Contact
              </a>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {user ? (
              <>
                {(user.user_type === "admin" ||
                  user.user_type === "super-admin") && (
                  <Link
                    to="/admin"
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-primary hover:text-orange transition-colors"
                  >
                    <FiSettings className="mr-2 text-orange" />
                    Admin
                  </Link>
                )}
                <Link
                  to="/dashboard"
                  className="inline-flex items-center px-4 py-2 text-sm font-medium text-primary hover:text-orange transition-colors"
                >
                  <FiUsers className="mr-2 text-orange" />
                  Dashboard
                </Link>

                {/* 🔸 New Logout Button */}
                <button
                  onClick={async () => {
                    try {
                      await signOut();
                      window.location.href = "/";
                    } catch (err) {
                      console.error("Logout failed:", err);
                    }
                  }}
                  className="inline-flex items-center px-4 py-2 text-sm font-medium text-primary hover:text-orange transition-colors"
                >
                  <FiLogOut className="mr-2 text-orange" />
                  Logout
                </button>
              </>
            ) : (
              <div className="flex items-center space-x-2">
                <button
                  onClick={onSignInClick}
                  className="inline-flex items-center px-4 py-2 text-sm font-medium text-primary hover:text-orange transition-colors"
                >
                  Sign In
                </button>
                <button
                  onClick={() => {
                    const chatButton = document.querySelector(
                      '[data-testid="chat-widget-button"]'
                    ) as HTMLButtonElement;
                    if (chatButton) {
                      chatButton.click();
                    }
                  }}
                  className="inline-flex items-center px-6 py-2 text-sm font-medium bg-orange text-white rounded-lg hover:bg-orange/90 transition-colors shadow-lg"
                >
                  <FiMessageCircle className="mr-2" />
                  Start Training
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

const HomePage = ({ onSignInClick }: { onSignInClick: () => void }) => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();


  const handleUpgrade = async (plan: "basic" | "premium") => {
  if (!user) {
    onSignInClick();
    return;
  }
  try {
    const response = await stripeAPI.createCheckoutSession(plan);
    if (response.success && response.url) {
      window.location.href = response.url;
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  } catch (error) {
    toast.error("Upgrade failed. Try again later.");
  }
};

  const handleOptionClick = (option: string) => {
    setShowModal(false);

    if (option === "member") {
      if (user) {
        window.open(
          "https://api.leadconnectorhq.com/widget/bookings/first-training-wodt",
          "_blank"
        );
      } else {
        onSignInClick();
      }
    }

    if (option === "subscriber") {
      if (user) {
        navigate("/dashboard");
      } else {
        onSignInClick();
      }
    }

    if (option === "guest") {
      window.open(
        "https://api.leadconnectorhq.com/widget/bookings/first-training-wodttjybiq",
        "_blank"
      );
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navigation onSignInClick={onSignInClick} />

      {/* Hero Section */}
      <div className="relative bg-dark-grey py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Rating Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-white rounded-full shadow-lg mb-8">
              <div className="flex items-center mr-2">
                {[...Array(5)].map((_, i) => (
                  <FiStar
                    key={i}
                    className="w-4 h-4 text-orange fill-current"
                  />
                ))}
              </div>
              <span className="text-lg font-bold text-primary">4.9</span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"} For The
              <span className="block text-orange">Real World</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
              Learn from advanced AI that understands your Dog's behavior,
              provides personalized training plans, and helps you become the
              confident Dog parent your furry friend deserves.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
              <button
                onClick={() => {
                  const chatButton = document.querySelector(
                    '[data-testid="chat-widget-button"]'
                  ) as HTMLButtonElement;
                  if (chatButton) {
                    chatButton.click();
                  }
                }}
                className="inline-flex items-center px-8 py-4 bg-orange text-white font-semibold rounded-lg text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
              >
                <FiPlay className="mr-3" />
                Start Your Free Training Session
              </button>
              <button
                onClick={() => {
                  const chatButton = document.querySelector(
                    '[data-testid="chat-widget-button"]'
                  ) as HTMLButtonElement;
                  if (chatButton) {
                    chatButton.click();
                  }
                }}
                className="inline-flex items-center px-8 py-4 border-2 border-orange text-orange font-semibold rounded-lg text-lg hover:bg-orange hover:text-white transition-all duration-200"
              >
                <FiMessageCircle className="mr-3" />
                Chat with {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-4xl font-bold text-orange mb-2">10K+</div>
                <div className="text-white font-medium">Dogs Trained</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange mb-2">24/7</div>
                <div className="text-white font-medium">Available</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange mb-2">99%</div>
                <div className="text-white font-medium">Success Rate</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange mb-2">50+</div>
                <div className="text-white font-medium">Training Methods</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How We Are Different */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-primary mb-4">
              How We Are Different
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-orange rounded-full flex items-center justify-center mx-auto mb-6">
                <FiZap className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-primary mb-4">
                Modern AI-Powered Training
              </h3>
              <p className="text-primary text-lg leading-relaxed">
                We believe there's more than one way to train your Dog. Our AI
                learns your dog 's unique personality and provides personalized
                training methods that work for both of you.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mx-auto mb-6">
                <FiHeart className="w-10 h-10 text-orange" />
              </div>
              <h3 className="text-2xl font-bold text-primary mb-4">
                We Teach You To Speak dog{" "}
              </h3>
              <p className="text-primary text-lg leading-relaxed">
                A huge part of our system is understanding your dog 's body
                language, behavior patterns, and needs. You'll learn to
                communicate effectively with your furry friend.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-orange rounded-full flex items-center justify-center mx-auto mb-6">
                <FiShield className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-primary mb-4">
                Focused On Your Priorities
              </h3>
              <p className="text-primary text-lg leading-relaxed">
                Our training isn't cookie-cutter. We learn what your priorities
                are and make them our priority too. Focus on the behaviors that
                matter most to you and your lifestyle.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div id="services" className="py-20 bg-dark-grey">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Services to Bark About
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-3xl font-bold text-primary mb-4">
                Private 1-on-1 AI Training Sessions
              </h3>
              <p className="text-primary text-lg mb-6 leading-relaxed">
                We work with you and coach you and your dog ! Finding yourself
                at a loss with what to do about your dog 's behavior? Our AI
                provides personalized, time-tested training methods that deliver
                results.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">
                    Personalized training plans
                  </span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">24/7 AI support</span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">Behavior analysis</span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">Progress tracking</span>
                </li>
              </ul>
              <button
                onClick={() => {
                  const chatButton = document.querySelector(
                    '[data-testid="chat-widget-button"]'
                  ) as HTMLButtonElement;
                  if (chatButton) {
                    chatButton.click();
                  }
                }}
                className="inline-flex items-center px-6 py-3 bg-orange text-white font-semibold rounded-lg hover:bg-orange/90 transition-colors"
              >
                Start Training Now
              </button>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-3xl font-bold text-primary mb-4">
                Advanced AI Behavior Analysis
              </h3>
              <p className="text-primary text-lg mb-6 leading-relaxed">
                Our AI doesn't just give advice - it understands your dog 's
                psychology, analyzes behavior patterns, and provides
                scientifically-backed training methods tailored to your specific
                situation.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">Deep behavior insights</span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">Breed-specific advice</span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">
                    Health and nutrition tips
                  </span>
                </li>
                <li className="flex items-center">
                  <FiCheck className="w-5 h-5 text-orange mr-3" />
                  <span className="text-primary">Emergency guidance</span>
                </li>
              </ul>
              <button
                onClick={() => {
                  const chatButton = document.querySelector(
                    '[data-testid="chat-widget-button"]'
                  ) as HTMLButtonElement;
                  if (chatButton) {
                    chatButton.click();
                  }
                }}
                className="inline-flex items-center px-6 py-3 bg-orange text-white font-semibold rounded-lg hover:bg-orange/90 transition-colors"
              >
                Get AI Analysis
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-primary mb-6">
                About {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}
              </h2>
              <p className="text-lg text-primary mb-6 leading-relaxed">
                <strong>
                  {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}
                </strong>{" "}
                is a heart-centered, results-driven AI dog training platform
                focused on ensuring you and your dog build a stronger bond
                through effective communication and training.
              </p>
              <p className="text-lg text-primary mb-6 leading-relaxed">
                Our AI system has been proven successful with thousands of dog
                s, helping them become more obedient, confident, and happy. We
                want to see you wagging your tail with excitement, confident in
                your ability to understand your dog so you can effectively
                communicate and enjoy each other to the fullest.
              </p>
              <p className="text-lg text-primary mb-8 leading-relaxed">
                No more struggling with training challenges! It's time to teach
                your <strong>"good dog "</strong> how to be GREAT, something
                we've mastered at dog AI Training – and something that you can
                master too!
              </p>
              <button
                onClick={() => {
                  const chatButton = document.querySelector(
                    '[data-testid="chat-widget-button"]'
                  ) as HTMLButtonElement;
                  if (chatButton) {
                    chatButton.click();
                  }
                }}
                className="inline-flex items-center px-6 py-3 bg-orange text-white font-semibold rounded-lg hover:bg-orange/90 transition-colors"
              >
                Start Your Journey
              </button>
            </div>
            <div className="bg-gradient-to-br from-orange to-accent rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">
                Our training system has produced life-changing results
              </h3>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">10K+</div>
                  <div className="text-sm">dog s Trained</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">99%</div>
                  <div className="text-sm">Success Rate</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">24/7</div>
                  <div className="text-sm">Available</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">50+</div>
                  <div className="text-sm">Training Methods</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div id="testimonials" className="py-20 bg-dark-grey">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              What dog Parents Say
            </h2>
            <p className="text-xl text-white/90">
              Real stories from real dog owners
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <FiStar
                    key={i}
                    className="w-5 h-5 text-orange fill-current"
                  />
                ))}
              </div>
              <p className="text-primary mb-6 leading-relaxed">
                "This AI helped me understand my rescue dog's anxiety. The
                training tips worked wonders and now we have a much stronger
                bond!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-orange rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold text-primary">Sarah M.</div>
                  <div className="text-primary/70">Dog Parent</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <FiStar
                    key={i}
                    className="w-5 h-5 text-orange fill-current"
                  />
                ))}
              </div>
              <p className="text-primary mb-6 leading-relaxed">
                "My dog's litter box issues were solved in one conversation. The
                AI understood exactly what was happening and gave me the perfect
                solution!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-accent rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold text-primary">Mike R.</div>
                  <div className="text-primary/70">Cat Parent</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <FiStar
                    key={i}
                    className="w-5 h-5 text-orange fill-current"
                  />
                ))}
              </div>
              <p className="text-primary mb-6 leading-relaxed">
                "The personalized training plans are incredible. My puppy
                learned commands in days and the AI helped me understand his
                behavior so much better!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-orange rounded-full mr-4"></div>
                <div>
                  <div className="font-semibold text-primary">Emma L.</div>
                  <div className="text-primary/70">Puppy Parent</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto text-center px-6 sm:px-8 lg:px-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Transform Your dog 's Life?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join thousands of dog parents who've discovered the power of
            AI-powered dog training
          </p>

          <div className="bg-white rounded-2xl p-12 shadow-2xl">
            <h3 className="text-3xl font-bold text-primary mb-10">
              Choose Your Plan
            </h3>

            {/* Plans */}
            <div className="grid md:grid-cols-3 gap-10 mb-16">
              {/* Basic */}
              <div className="border rounded-2xl p-10 shadow hover:shadow-xl transition min-h-[480px] w-full flex flex-col justify-between">
                <div>
                  <h4 className="text-2xl font-bold text-primary mb-3">
                    Basic
                  </h4>
                  <p className="text-3xl font-bold text-orange mb-3">$9.99</p>
                  <p className="text-base text-primary mb-6">per month</p>
                  <ul className="text-base text-primary space-y-3 mb-6 text-left">
                    <li>✔ 1000 text messages</li>
                    <li>✔ 20 voice minutes</li>
                    <li>✔ 10 image uploads</li>
                    <li>✔ Voice Notes + Image Analysis</li>
                  </ul>
                </div>
<button
  onClick={() => handleUpgrade("basic")}
  className="w-full py-3 text-lg bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition"
>
  Start Basic Plan
</button>
              </div>

              {/* Premium */}
              <div className="border-2 border-orange bg-orange/10 rounded-2xl p-10 shadow-lg hover:shadow-2xl transition relative min-h-[520px] w-full flex flex-col justify-between">
                <span className="absolute top-0 right-0 bg-orange text-white text-xs font-bold px-4 py-1 rounded-bl-lg">
                  Most Popular
                </span>
                <div>
                  <h4 className="text-2xl font-bold text-primary mb-3">
                    Premium
                  </h4>
                  <p className="text-3xl font-bold text-orange mb-3">$19.99</p>
                  <p className="text-base text-primary mb-6">per month</p>
                  <ul className="text-base text-primary space-y-3 mb-6 text-left">
                    <li>✔ 2500 text messages</li>
                    <li>✔ 50 voice minutes</li>
                    <li>✔ 15 image uploads</li>
                    <li>✔ Everything in Basic plan</li>
                    <li>✔ Pre-recorded video recommendation & guidance</li>
                  </ul>
                </div>
<button
  onClick={() => handleUpgrade("premium")}
  className="w-full py-3 text-lg bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition"
>
  Start Premium Plan
</button>
              </div>

              {/* Ultimate */}
              <div className="border rounded-2xl p-10 shadow hover:shadow-xl transition opacity-70 relative min-h-[480px] w-full flex flex-col justify-between">
                <span className="absolute top-0 right-0 bg-gray-400 text-white text-xs font-bold px-4 py-1 rounded-bl-lg">
                  Coming Soon
                </span>
                <div>
                  <h4 className="text-2xl font-bold text-primary mb-3">
                    Ultimate
                  </h4>
                  <p className="text-3xl font-bold text-orange mb-3">$29.99</p>
                  <p className="text-base text-primary mb-6">per month</p>
                  <ul className="text-base text-primary space-y-3 mb-6 text-left">
                    <li>✔ 4000 text messages</li>
                    <li>✔ 75 voice minutes</li>
                    <li>✔ 25 image uploads</li>
                    <li>✔ Everything in Premium plan</li>
                    <li>✔ Video upload analysis</li>
                  </ul>
                </div>
                <button
                  disabled
                  className="w-full py-3 text-lg bg-gray-400 text-white rounded-lg font-semibold cursor-not-allowed"
                >
                  Coming Soon
                </button>
              </div>
            </div>

            {/* Single Consultation Card */}
            <h3 className="text-3xl font-bold text-primary mb-10">
              Book 1:1 Consultation
            </h3>
            <div className="mb-16">
              <div className="bg-gray-50 border rounded-2xl p-10 shadow hover:shadow-lg transition text-left min-h-[280px] w-full flex flex-col justify-between relative">
                <div>
                  <h4 className="text-xl font-bold text-primary mb-3">
                    Consultation with Ryan Mathews
                  </h4>
                  <p className="text-base text-primary/80 mb-5">
                    Get expert advice from Ryan Mathews through a personalized
                    consultation session. Whether you’re a subscriber or a guest
                    — we’ve got you covered!
                  </p>
                  <p className="text-lg text-orange font-semibold">
                    $99.99 / session (Subscribers)
                  </p>
                  <p className="text-lg text-orange font-semibold">
                    $149.99 / session (Non-Subscribers)
                  </p>
                </div>
                <div className="flex justify-end mt-6">
                  <button
                    onClick={() => setShowModal(true)}
                    className="px-6 py-3 bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition"
                  >
                    Book Consultation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 overflow-y-auto">
            <div className="relative bg-white rounded-2xl p-8 shadow-2xl max-w-3xl w-full text-center my-10">
              {/* ❌ Close button (top-right) */}
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition transform hover:scale-110"
                title="Close"
              >
                ✕
              </button>

              <h2 className="text-2xl font-bold text-primary mb-6">
                Choose an Option
              </h2>

              <div className="space-y-4">
                {/* Already a Subscriber */}
                <button
                  onClick={() => handleOptionClick("member")}
                  className="w-full py-3 bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition flex items-center justify-between px-4"
                >
                  <span>Already a Subscriber</span>
                  <span className="text-sm font-normal">$99.99</span>
                </button>

                {/* Continue Without Subscription */}
                <button
                  onClick={() => handleOptionClick("guest")}
                  className="w-full py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition flex items-center justify-between px-4"
                >
                  <span>Continue Without Subscription</span>
                  <span className="text-sm font-normal">$149.99</span>
                </button>
              </div>

              {/* ---- New Section ---- */}
              <div className="mt-10 text-left">
                <h3 className="text-2xl font-bold text-primary mb-6 text-center">
                  Become a Subscriber
                </h3>

                <div className="grid md:grid-cols-3 gap-8">
                  {/* Basic Plan */}
                  <div className="border rounded-2xl p-6 shadow hover:shadow-xl transition flex flex-col justify-between">
                    <div>
                      <h4 className="text-xl font-bold text-primary mb-2">
                        Basic
                      </h4>
                      <p className="text-2xl font-bold text-orange mb-1">
                        $9.99
                      </p>
                      <p className="text-sm text-primary mb-4">per month</p>
                      <ul className="text-sm text-primary space-y-2 mb-4">
                        <li>✔ 1000 text messages</li>
                        <li>✔ 20 voice minutes</li>
                        <li>✔ 10 image uploads</li>
                        <li>✔ Voice Notes + Image Analysis</li>
                      </ul>
                    </div>
<button
  onClick={() => handleUpgrade("basic")}
  className="w-full py-2 bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition"
>
  Start Basic Plan
</button>     </div>

                  {/* Premium Plan */}
                  <div className="border-2 border-orange bg-orange/10 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition flex flex-col justify-between relative">
                    <span className="absolute top-0 right-0 bg-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
                      Most Popular
                    </span>
                    <div>
                      <h4 className="text-xl font-bold text-primary mb-2">
                        Premium
                      </h4>
                      <p className="text-2xl font-bold text-orange mb-1">
                        $19.99
                      </p>
                      <p className="text-sm text-primary mb-4">per month</p>
                      <ul className="text-sm text-primary space-y-2 mb-4">
                        <li>✔ 2500 text messages</li>
                        <li>✔ 50 voice minutes</li>
                        <li>✔ 15 image uploads</li>
                        <li>✔ Everything in Basic plan</li>
                        <li>✔ Pre-recorded video guidance</li>
                      </ul>
                    </div>
<button
  onClick={() => handleUpgrade("premium")}
  className="w-full py-2 bg-orange text-white rounded-lg font-semibold hover:bg-orange/90 transition"
>
  Start Premium Plan
</button>
                  </div>

                  {/* Ultimate Plan */}
                  <div className="border rounded-2xl p-6 shadow hover:shadow-xl transition opacity-70 flex flex-col justify-between relative">
                    <span className="absolute top-0 right-0 bg-gray-400 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
                      Coming Soon
                    </span>
                    <div>
                      <h4 className="text-xl font-bold text-primary mb-2">
                        Ultimate
                      </h4>
                      <p className="text-2xl font-bold text-orange mb-1">
                        $29.99
                      </p>
                      <p className="text-sm text-primary mb-4">per month</p>
                      <ul className="text-sm text-primary space-y-2 mb-4">
                        <li>✔ 4000 text messages</li>
                        <li>✔ 75 voice minutes</li>
                        <li>✔ 25 image uploads</li>
                        <li>✔ Everything in Premium plan</li>
                        <li>✔ Video upload analysis</li>
                      </ul>
                    </div>
                    <button
                      disabled
                      className="w-full py-2 bg-gray-400 text-white rounded-lg font-semibold cursor-not-allowed"
                    >
                      Coming Soon
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="py-20 bg-gradient-to-r from-orange to-accent">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Transform Your dog 's Life?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join thousands of dog parents who've discovered the power of
            AI-powered dog training
          </p>
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h3 className="text-2xl font-bold text-primary mb-4">
              Start Your Free Training Session
            </h3>
            <p className="text-primary mb-6">
              Click the chat button below to begin your dog training journey
              with our AI companion!
            </p>
            <button
              onClick={() => {
                const chatButton = document.querySelector(
                  '[data-testid="chat-widget-button"]'
                ) as HTMLButtonElement;
                if (chatButton) {
                  chatButton.click();
                }
              }}
              className="inline-flex items-center px-8 py-4 bg-orange text-white font-semibold rounded-lg text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              <FaPaw className="text-white mr-2" size={24} />
              Start Chatting Now
            </button>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-primary mb-4">
              Get In Touch
            </h2>
            <p className="text-xl text-primary">
              Have questions? We're here to help!
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-orange rounded-full flex items-center justify-center mb-4">
                <FiPhone className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">Call Us</h3>
              <p className="text-primary">24/7 AI Support Available</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mb-4">
                <FiMail className="w-8 h-8 text-orange" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">Email Us</h3>
              <p className="text-primary">support@AIdog Assistant.com</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-orange rounded-full flex items-center justify-center mb-4">
                <FiMapPin className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">
                Available Everywhere
              </h3>
              <p className="text-primary">Worldwide AI Training</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold text-orange mb-4 flex items-center">
                <FaPaw className="text-orange mr-2" size={24} />
                {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}
              </h3>
              <p className="text-white/70">
                Your intelligent{" "}
                {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"} companion
                powered by AI.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-white/70">
                <li>AI Training Sessions</li>
                <li>Behavior Analysis</li>
                <li>Personalized Plans</li>
                <li>24/7 Support</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-white/70">
                <li>Help Center</li>
                <li>Contact Us</li>
                <li>Privacy Policy</li>
                <li>Terms of Service</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Connect</h4>
              <p className="text-white/70">
                Follow us for dog training tips and updates.
              </p>
            </div>
          </div>
          <div className="border-t border-white/20 mt-8 pt-8 text-center">
            <p className="text-white/70">
              © 2024 {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}.
              Making {process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI"}{" "}
              smarter, one conversation at a time.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

function AppContent() {
  const [showAuthModal, setShowAuthModal] = React.useState(false);
  const handleOpenAuth = () => setShowAuthModal(true);
  const handleCloseAuth = () => setShowAuthModal(false);

  // Set document title dynamically
  React.useEffect(() => {
    const title = process.env.REACT_APP_WIDGET_TITLE || "K9 Coach AI";
    document.title = title;
  }, []);

  // Global error handler for toFixed errors
  React.useEffect(() => {
    const handleError = (error: ErrorEvent) => {
      console.error("Global error caught:", error);
      if (error.message.includes("toFixed")) {
        console.error("toFixed error detected, preventing crash...");
        error.preventDefault();
        return false;
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Toaster position="top-center" />
        <Routes>
          <Route
            path="/"
            element={<HomePage onSignInClick={handleOpenAuth} />}
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <UserDashboard />
              </PrivateRoute>
            }
          />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
        </Routes>
        <ChatWidget />
        {showAuthModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.35)",
              zIndex: 20000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AuthForm
              variant="modal"
              onAuthSuccess={handleCloseAuth}
              onClose={handleCloseAuth}
            />
          </div>
        )}
      </div>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <AppContent />
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;
